import { SourcingChannelStatus, SourcingService } from 'api-clients/monolith';

import { DateRangeFilter } from '@/contexts/table-context';

type CampaignsQueryParams = {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
  channelIds?: string[];
  statuses?: string[];
  positionIds?: string[];
  locationIds?: string[];
  brandIds?: string[];
  dateRange?: DateRangeFilter;
};

/**
 * The openings[] filter is intentionally omitted — no UI in the Filters bar
 * surfaces it today.
 */
export function getCampaigns(params: CampaignsQueryParams) {
  return SourcingService.getInternalApiSourcingCampaigns(
    params.dateRange?.preset,
    params.dateRange?.startDate,
    params.dateRange?.endDate,
    params.channelIds,
    params.statuses as SourcingChannelStatus[] | undefined,
    params.positionIds,
    params.locationIds,
    params.brandIds,
    undefined,
    params.search,
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDir,
  );
}
